import React from "react";
import { Link } from "react-router-dom";

const base =
  "inline-flex items-center justify-center gap-2 px-6 py-3 font-medium transition-colors text-[15px] tracking-tight btn-shine";

const variants = {
  primary: "bg-[#254369] text-white hover:bg-[#2D2D37]",
  gold: "bg-[#C9A961] text-white hover:bg-[#b09252]",
  outline: "border-2 border-[#254369] text-[#254369] hover:bg-[#F5F5F5]",
  outlineLight: "border-2 border-white/70 text-white hover:bg-white/10",
  ghostGold: "border-2 border-[#C9A961] text-[#C9A961] hover:bg-[#C9A961] hover:text-white",
};

export const Btn = ({ href = "#", variant = "primary", children, testid, pill = false }) => {
  const cls = `${base} ${pill ? "rounded-full" : "rounded-lg"} ${variants[variant]}`;
  // Internal SPA routes use Link; same-page anchors and tel:/mailto: stay in
  // the same tab; only true external URLs open a new tab.
  if (href.startsWith("/")) {
    return (
      <Link to={href} data-testid={testid} className={cls}>
        {children}
      </Link>
    );
  }
  if (href.startsWith("#") || href.startsWith("tel:") || href.startsWith("mailto:")) {
    return (
      <a href={href} data-testid={testid} className={cls}>
        {children}
      </a>
    );
  }
  return (
    <a href={href} data-testid={testid} target="_blank" rel="noopener noreferrer" className={cls}>
      {children}
    </a>
  );
};

export const SectionHeading = ({ eyebrow, title, subtitle, light = false, center = false }) => (
  <div className={`${center ? "text-center mx-auto" : ""} max-w-3xl`}>
    {eyebrow && (
      <p className="text-[#C9A961] font-heading font-bold uppercase tracking-[0.18em] text-xs mb-3">
        {eyebrow}
      </p>
    )}
    <h2
      className={`font-heading font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-[2.75rem] leading-[1.1] ${
        light ? "text-white" : "text-[#2D2D37]"
      }`}
    >
      {title}
    </h2>
    {subtitle && (
      <p className={`mt-5 text-base sm:text-lg leading-relaxed ${light ? "text-white/80" : "text-[#2D2D37]/70"}`}>
        {subtitle}
      </p>
    )}
  </div>
);
